export const DEFAULT_SEAT_COLORS = [
  '#1DD300',
  '#F80012',
  '#ffc107',
  '#F43FA5',
  '#6f42c1',
  '#006663',
  '#fd7e14',
  '#3914af',
  '#6610f2',
  '#FF1493',
  '#FF4500',
  '#FFD700',
  '#6c757d',
] as const;

export const SEAT_STATE_COLORS = {
  SELECTED: '#ffff00',
  HOVERED: '#ffaa44',
  BOOKED: '#ccccccff',
  DEFAULT: '#ccccff',
} as const;
